import { render, staticRenderFns } from "./MenuManagement.vue?vue&type=template&id=763ddab8&"
import script from "./MenuManagement.vue?vue&type=script&lang=js&"
export * from "./MenuManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports